export default __webpack_public_path__ + "static/media/11ba3feacb160f3c29ea8cbeb20a99c7.jpg";